const state = {
    totalProduceTimeFields: [
        {
            key: "code",
            label: "製程",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "device_name",
            label: "機台編號",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "startTime",
            label: "開始時間",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "endTime",
            label: "結束時間",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "totalTime",
            label: "生產時間",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
    ],
    totalProduceTimeItem: [],
    totalProduceTiming: "",
}
const getters = {
    get_totalProduceTimeFields: state => {
        return state.totalProduceTimeFields
    },
    get_totalProduceTimeItem: state => {
        return state.totalProduceTimeItem
    },
    get_totalProduceTiming: state => {
        return state.totalProduceTiming
    },
}
const actions = {
    set_totalProduceTimeFields(context, array) {
        context.commit('SET_TOTALPRODUCETIMEFIELDS', array);
    },
    set_totalProduceTimeItem(context, array) {
        context.commit('SET_TOTALPRODUCETIMEITEM', array);
    },
    set_totalProduceTiming(context, string) {
        context.commit('SET_TOTALPRODUCETIMING', string);
    },
}
const mutations = {
    SET_TOTALPRODUCETIMEFIELDS(state, array) {
        state.totalProduceTimeFields = array;
    },
    SET_TOTALPRODUCETIMEITEM(state, array) {
        state.totalProduceTimeItem = array;
    },
    SET_TOTALPRODUCETIMING(state, string) {
        state.totalProduceTiming = string;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/totalProduceTime.js